import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { ExportTypesEnum } from '../enums/export-types.enum';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { IExportData } from './../store/actions/events.action';

@Injectable({
    providedIn: 'root',
})
export class DataExportService {
    constructor(private http: HttpClient) {}

    public exportData(payload: any): Observable<any> {
        let route: SubUrlsEnum;
        switch (payload.dataType) {
            case ExportTypesEnum.MEALS:
                route = SubUrlsEnum.EXPORT_MEALS;
                break;
            case ExportTypesEnum.HOMEWORKS:
                route = SubUrlsEnum.EXPORT_HOMEWORKS;
                break;
            case ExportTypesEnum.POINTINGS:
                route = SubUrlsEnum.EXPORT_POINTINGS;
                break;
            case ExportTypesEnum.WALLETS:
                route = SubUrlsEnum.EXPORT_WALLETS;
                break;
            case ExportTypesEnum.ATTESTATIONS_CSV:
                route = SubUrlsEnum.EXPORT_TAX_RETURN_CSV;
                break;
            case ExportTypesEnum.ATTESTATIONS_PDF:
                route = SubUrlsEnum.EXPORT_TAX_RETURN_PDF;
                break;
        }
        let params: HttpParams = new HttpParams();

        for (const key in payload) {
            const value: any = payload[key];

            if (value !== null && value !== undefined) {
                if (Array.isArray(value) && value.length) {
                    params = params.set(key, value.join(','));
                } else {
                    params = params.set(key, `${value}`);
                }
            }
        }

        const type: any = payload.dataType === ExportTypesEnum.ATTESTATIONS_PDF ? 'blob' : 'text';

        return this.http
            .get(environment.wasoApi + route, {
                params: params,
                responseType: type,
            })
            .pipe(
                tap((response: ArrayBuffer) => {
                    if (response) {
                        if (payload.dataType === ExportTypesEnum.ATTESTATIONS_PDF) {
                            const blob: Blob = new Blob([response], {
                                type: 'application/zip',
                            });
                            saveAs(blob, payload.fileName);
                        } else {
                            const blob: Blob = new Blob(['\ufeff', response], {
                                type: 'text/csv',
                            });
                            saveAs(blob, payload.fileName);
                        }
                    }
                })
            );
    }
}
